import React, { useEffect } from 'react';
import VitalsDisplayPanel from './VitalsDisplayPanel/VitalsDisplayPanel';
import { useVitals } from './VitalsDisplayPanel/VitalsContext';

function MemberProfileDetails({ memberId }) {
    const { vitalsData, setMemberId, isLoading, ranges, vitals, fetchSingleVitalGraph, vitalStatsInfo,vitalStatsRanges } = useVitals();

    useEffect(() => { 
        setMemberId(memberId); 
    }, [memberId]); 

    return (
        <VitalsDisplayPanel memberId={memberId} vitalsDataProp={vitalsData} ranges={ranges} isLoading={isLoading} vitals={vitals} fetchSingleVitalGraph={fetchSingleVitalGraph} vitalStatsInfo={vitalStatsInfo} vitalStatsRanges={vitalStatsRanges}  />
    );
}

export default MemberProfileDetails;